import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CircleHalfStroke({ className, size = 24 }) {
    return (_jsxs("svg", { className: className, height: size, width: size, viewBox: "0 0 24 24", fill: "none", children: [_jsx("path", { d: "M2 12C2 17.5228 6.47715 22 12 22V2C6.47715 2 2 6.47715 2 12Z", fill: "currentColor" }), _jsx("circle", { cx: "12", cy: "12", r: "9.25", stroke: "currentColor", strokeWidth: "1.5" })] }));
}
export default CircleHalfStroke;
